import React from 'react'
import { useAuth } from 'context/authentication/useAuth'

/**
 * Displays the "signed in as: [email]" section of the footer.
 *
 * Shows the currently authenticated user's email address with appropriate styling.
 * Used consistently across all footer variants.
 */
export const FooterSignedInAs: React.FC = () => {
  const { user } = useAuth()

  return (
    <div className="flex items-center gap-1 text-sm">
      <span className="text-zinc-900 font-light leading-6">signed in as: </span>
      <span className="text-zinc-900 font-medium leading-6">
        {user?.email || ''}
      </span>
    </div>
  )
}
